/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartPriceData } from "../data/useChartPriceData";
import { useChartIndexData } from "../data/useChartIndexData";
import { useHighchartTransformer } from "../transformers/useHighchartTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useExportSource } from "../hooks/useExportSource";
import { useCorrelationLabel } from "../hooks/useCorrelationLabel";
import { useSubscriptionSource } from "../../../shared";

export const ComponentChart: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResultPrice = useHookSubscribe(null, context.olapResultPrice$);
  const olapResultIndex = useHookSubscribe(null, context.olapResultIndex$);
  const source = useHookSubscribe(null, context.sources$);
  const loading = useHookSubscribe(null, context.loading$);
  useExportSource(source);
  useSubscriptionSource(source);

  const chartPriceData = useChartPriceData(olapResultPrice);
  const chartIndexData = useChartIndexData(olapResultIndex);
  const highchartData = useHighchartTransformer(chartPriceData, chartIndexData);
  const correlationLabel = useCorrelationLabel(chartIndexData);

  if (window["exportMode"]) {
    window["exportReady"] = !loading;
  }

  if (loading) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentTitle>Strong Long-term Correlation (={correlationLabel})</ComponentTitle>
      <ComponentSourcetitle>Source: {source || "USDA Prices, EIA"}</ComponentSourcetitle>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
      <ComponentFootnote>*Corn Grain, Wheat and Soybean are considered in the calculation of Crop Price Index</ComponentFootnote>
    </>
  );
};
